export default "__VITE_ASSET__095c22f2__"